import { createModel } from '@rematch/core';
import { bryt } from '../../http';

export const transactions = createModel()({
  name: 'transactions',
  state: {
    loading: false,
    transactions: [],
  },
  reducers: {
    setLoading(state, payload) {
      state.loading = payload;
    },
    setTransactions(state, payload) {
      state.transactions = payload;
    },
  },
  effects: dispatch => ({
    async handleGetAllTxs() {
      try {
        dispatch.transactions.setLoading(true);
        const res = await bryt.getAllTx();
        const transactionHases = res.result.transaction;
        const result = await Promise.all(
          transactionHases.map(async tx => {
            return bryt.getTransactionByHash(tx);
          })
        );

        const transactions = result.map(tx => tx.result.transaction);

        dispatch.transactions.setTransactions(transactions);
      } catch (err) {
        console.log(err.message);
      } finally {
        dispatch.transactions.setLoading(false);
      }
    },
  }),
});
